import styled from 'styled-components';
import BaseInput from 'components/Input';
import BaseButton from 'components/Button';

export const Input = styled(BaseInput)`
  margin: 16px 0px;
`;

export const Button = styled(BaseButton)`
  margin-left: auto;
  margin-right: auto;
  display: block;
  width: 170px;
  height: 34px;
  padding: 0;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: #888888;
`;
